// import { useState, useEffect } from "react";
// import { projectStorage } from "components/ProjectStorage";

export const PreviewStorageUrl = (previewInput, previewOutput) => {
  // const [previewInputFile, setPreviewInputFile] = useState();
  // const [previewOutputFile, setPreviewOutputFile] = useState();
  // const [previewInputFile, setPreviewInputFile] = useState("/images/market/no-img.png");
  // const [previewOutputFile, setPreviewOutputFile] = useState("/images/market/no-img.png");

  // useEffect(() => {
  //   if (previewInput) getFileUrl("input", previewInput);
  //   if (previewOutput) getFileUrl("output", previewOutput);
  // }, [previewInput, previewOutput]);

  // /* image url 가져오기 */
  // const getFileUrl = (type, paramUrl) => {
  //   const storageFileRef = projectStorage.ref(paramUrl);

  //   storageFileRef
  //     .getDownloadURL()
  //     .then((url) => {
  //       try {
  //         if (type === "input") setPreviewInputFile(url);
  //         if (type === "output") setPreviewOutputFile(url);
  //       } catch (e) {
  //         console.log(e);
  //       }
  //     })
  //     .catch((error) => {
  //       console.log("error : ", error);
  //       return { previewInputFile, previewOutputFile };
  //     });
  // };
  let previewInputFile="/images/market/no-img.png";
  let previewOutputFile="/images/market/no-img.png";
  if (previewInput)
    previewInputFile = "https://firebasestorage.googleapis.com/v0/b/aiso-api.appspot.com/o/" + encodeURIComponent(previewInput) +"?alt=media";
  if (previewOutput)
    previewOutputFile = "https://firebasestorage.googleapis.com/v0/b/aiso-api.appspot.com/o/" + encodeURIComponent(previewOutput) +"?alt=media";

  return { previewInputFile, previewOutputFile };
};
